export default "__VITE_ASSET__BHX9$sls__"